<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card class="custom-light-blue">
      <v-btn
        fab
        absolute
        right
        color="#29284c"
        depressed
        class="white--text mt-2"
        x-small
        @click="$emit('input', false)"
        style="margin-right: -8px"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-tabs v-model="tabs" centered fixed-tabs dark background-color="primary">
        <v-tab v-for="(item, index) in items" :key="index + item.text">
          <v-icon left>{{ item.icon }}</v-icon>
          <span v-if="!$vuetify.breakpoint.mdAndDown">{{ item.text }}</span>
        </v-tab>
        <v-tab-item class="custom-light-blue">
          <v-container>
            <app-lesson-settings :value="value" @edited-lesson="$emit('edited-lesson', $event)" />
          </v-container>
        </v-tab-item>
        <v-tab-item class="custom-light-blue">
          <v-container>
            <app-teacher :value="value" location="LIVE" :step="steps['Live Lesson']" />
          </v-container>
        </v-tab-item>
        <v-tab-item class="custom-light-blue">
          <v-container>
            <app-teacher
              :value="value"
              location="PRACTICE"
              :step="steps['Lesson Practice']"
              direction="practice"
            />
          </v-container>
        </v-tab-item>
        <v-tab-item class="custom-light-blue">
          <v-container>
            <app-exercises :value="value" />
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<script>
import Teacher from "./Teacher.vue";
import Exercises from "./Grammar/Exercises.vue";
import LessonSettings from "./Lesson Settings.vue";

export default {
  components: {
    appTeacher: Teacher,
    appExercises: Exercises,
    appLessonSettings: LessonSettings,
  },
  props: {
    value: {
      required: false,
      default: false,
      type: Boolean,
    },
    steps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabs: 0,
      items: [
        {
          icon: "mdi-tools",
          text: "Lesson Settings",
        },
        {
          icon: "mdi-human-male-board-poll",
          text: "Live Lesson",
        },
        {
          icon: "mdi-book-open-page-variant",
          text: "Lesson Practice",
        },
        {
          icon: "mdi-school",
          text: "Sentence Structure",
        },
      ],
    };
  },
};
</script>
<style scoped>
.custom-light-blue {
  background-color: #f0faff;
}
</style>
